// amplify-auth.service.ts

import { Injectable } from '@angular/core';
import { AmplifyAuthAdapterService } from '../adapters/amplify-auth-adapter.service';

type FetchAuthSessionInput = Parameters<AmplifyAuthAdapterService['fetchAuthSession']>[0];
type FetchAuthSessionOutput = Awaited<ReturnType<AmplifyAuthAdapterService['fetchAuthSession']>>;

type GetCurrentUserOutput = Awaited<ReturnType<AmplifyAuthAdapterService['getCurrentUser']>>;

type SignOutInput = Parameters<AmplifyAuthAdapterService['signOut']>[0];

type SignInWithRedirectInput = Parameters<AmplifyAuthAdapterService['signInWithRedirect']>[0];

@Injectable({
  providedIn: 'root'
})
export class AmplifyAuthService {
  constructor(private readonly amplifyAuthAdapter: AmplifyAuthAdapterService) {}

  fetchAuthSession(options?: FetchAuthSessionInput): Promise<FetchAuthSessionOutput> {
    return this.amplifyAuthAdapter.fetchAuthSession(options);
  }

  getCurrentUser(): Promise<GetCurrentUserOutput> {
    return this.amplifyAuthAdapter.getCurrentUser();
  }

  signOut(input?: SignOutInput): Promise<void> {
    return this.amplifyAuthAdapter.signOut(input);
  }

  signInWithRedirect(input?: SignInWithRedirectInput): Promise<void> {
    return this.amplifyAuthAdapter.signInWithRedirect(input);
  }
}
